'use client';

import { useState } from 'react';
import { CTATag } from '../../atoms/CTA/CTA.constants';
import Container from '~/grid/Container';
import Col from '~/grid/Col';
import Row from '~/grid/Row';
import {
  JobAlertWithFilters,
  RenderCopyText,
  submitOnEnter,
} from './JobAlert.helpers';
import {
  JobAlertContainer,
  AlertHeadline,
  SubscribeDataProtectionText,
  FormContainer,
  StyledInput,
  StyledCTA,
  VerticalSeparator,
} from './JobAlert.styles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGetRichTextValues } from '~/config/useGetRichtTextValues';

/**
 * @param {JobAlertProps} props
 * @returns {React.ReactElement} The rendered component
 */
const JobAlert = ({
  handleSubmit,
  filters,
  jobAlertState,
  resetState,
  jobAdsCount,
}) => {
  const { richTextValues } = useGetRichTextValues();
  const [inputValue, setInputValue] = useState('');
  const intl = useIntl();

  return (
    <JobAlertContainer jobAdsCount={jobAdsCount}>
      <Container>
        <Row>
          <Col colAmount={{ xl: 10, lg: 10, md: 10, sm: 12, xs: 12 }}>
            {jobAdsCount !== 0 && (
              <AlertHeadline>
                {intl.formatMessage({
                  id: 'jobAlert.headline',
                })}
              </AlertHeadline>
            )}
            {!filters ||
              (filters.length === 0 && (
                <SubscribeDataProtectionText>
                  {intl.formatMessage({
                    id: 'jobAlert.noFiltersText',
                  })}
                  <br />
                  <br />
                  <FormattedMessage
                    id="jobAlert.privacyText"
                    values={{
                      disclaimerUrl: (chunks) => (
                        <a href={richTextValues.disclaimerUrl}>{chunks}</a>
                      ),
                      privacyPolicyUrl: (chunks) => (
                        <a href={richTextValues.privacyPolicyUrl}>{chunks}</a>
                      ),
                    }}
                  />
                </SubscribeDataProtectionText>
              ))}
            {filters && filters.length > 0 && (
              <JobAlertWithFilters filters={filters} />
            )}
            <VerticalSeparator size="30px" />
            <RenderCopyText
              state={jobAlertState}
              resetState={resetState}
              jobAdsCount={jobAdsCount}
            />
            {jobAlertState === '' && (
              <FormContainer>
                <StyledInput
                  onChange={(e) => setInputValue(e?.currentTarget?.value ?? '')}
                  value={inputValue}
                  placeholder={intl.formatMessage({
                    id: 'jobAlert.inputPlaceholder',
                  })}
                  onFocus={(e) => {
                    e.target.placeholder = '';
                  }}
                  onBlur={(e) => {
                    e.target.placeholder = intl.formatMessage({
                      id: 'jobAlert.inputPlaceholder',
                    });
                  }}
                  onKeyUp={(event) =>
                    submitOnEnter(event, () =>
                      handleSubmit(inputValue, () => setInputValue('')),
                    )
                  }
                  jobAdsCount={jobAdsCount}
                />
                <StyledCTA
                  skin="PRIMARY"
                  type={CTATag.Button}
                  title={intl.formatMessage({
                    id: 'jobAlert.buttonText',
                  })}
                  text={intl.formatMessage({
                    id: 'jobAlert.buttonText',
                  })}
                  handleBtnClick={() =>
                    handleSubmit(inputValue, () => setInputValue(''))
                  }
                  jobAdsCount={jobAdsCount}
                  isBrand
                />
              </FormContainer>
            )}
          </Col>
        </Row>
      </Container>
    </JobAlertContainer>
  );
};

export default JobAlert;
